<style scoped>
    .table-header{
        padding: 5px;
        text-align: center;
    }
</style>
<template>
  <div>
    <Table
      size="small"
      :columns="period_columns"
      :data="periods"
      :loading="loading"
    >
      <div
        slot="header"
        class="table-header"
      >
        <span class="text-bold">项目阶段定义</span>
        <Button
          type="primary"
          icon="md-add"
          @click="editPeriod(new_period)"
        >
          添加
        </Button>
      </div>
    </Table>

    <Modal
      v-model="period_config.modal"
      transfer
      title="添加 / 修改"
      ok-text="保存"
      :loading="period_config.loading"
      @on-ok="editPeriodOk"
    >
      <Form
        ref="periodForm"
        :model="edit_period"
        :label-width="140"
      >
        <Form-item label="项目发展阶段">
          <Input
            v-model="edit_period.name"
            placeholder="请输入"
          />
        </Form-item>
        <Form-item label="费用池额度">
          <Input
            v-model="edit_period.expense_pool"
            placeholder="请输入"
          />
        </Form-item>
        <Form-item label="学习团建费人均标准">
          <Input
            v-model="edit_period.expense_study_per_person"
            placeholder="请输入"
          />
        </Form-item>
        <Form-item label="备注">
          <Input
            v-model="edit_period.remark"
            type="textarea"
            placeholder="请输入"
          />
        </Form-item>
      </Form>
    </Modal>

    <div class="hr" />

    <MonthData
      :periods="periods"
      :period_hash="period_hash"
    />
  </div>
</template>
<script route="/fin_report_v2/setting/fin_team_period">
  import MonthData from './components/fin_team_month_period';
  export default {
    /* router_info_start */
    router_info: '/fin_report_v2/setting/fin_team_period',
    /* router_info_end */

    components: { MonthData },
    data() {
      return {
        loading: false,
        periods: [],
        period_hash: {},
        period_columns: [
          {
            title: '项目发展阶段',
            align: 'center',
            key: 'name'
          },
          {
            title: '费用池额度',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatPrice(row.expense_pool));
            }
          },
          {
            title: '学习团建费人均标准',
            align: 'right',
            render: (h, params) => {
              const row = params.row;
              return h('span', Util.formatPrice(row.expense_study_per_person));
            }
          },
          {
            title: '备注',
            align: 'center',
            key: 'remark'
          },
          {
            title: '操作',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('Button', {
                props: {
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editPeriod(row);
                  }
                }
              }, '编辑');
            }
          }
        ],
        new_period: {
          name: '',
          remark: '',
          expense_pool: '',
          expense_study_per_person: '',
          period_level: 0
        },
        edit_period: {},
        period_config: {
          modal: false,
          loading: true
        }
      }
    },
    computed: {
      //
    },
    created() {
      this.getPeriods();
    },
    mounted() {
      //
    },
    methods: {
      editPeriod(period) {
        this.edit_period = Util.clone(period);
        this.period_config.modal = true;
        console.log('----')
      },
      getPeriods() {
        this.loading = true;
        Util.ajax.get(Util.api.fin_team_period_list).then((response) => {
          return response.data;
        }).then((res) => {
          this.loading = false;
          if (res.code === 1) {
            const data = res.data;
            this.periods = data.periods;
            this.genPeriodHash();
          } else {
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          this.loading = false;
          console.log(e);
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      genPeriodHash() {
        this.periods.forEach((period) => {
          this.period_hash[period.id] = period;
        });
      },
      editPeriodOk() {
        Util.ajax.post(Util.api.update_fin_team_period, this.edit_period).then((response) => {
          return response.data;
        }).then((res) => {
          if (res.code === 1) {
            this.period_config.modal = false;
            const data = res.data;
            Util.insertOrUpdateArrayItem(this.periods, data.period);
          } else {
            this.resetPeriodUpdateLoading();
            this.$Modal.warning({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
          this.resetPeriodUpdateLoading();
          this.$Modal.warning({
            title: '错误',
            content: e.message
          });
        });
      },
      resetPeriodUpdateLoading() {
        this.period_config.loading = false;
        setTimeout(() => {
          this.period_config.loading = true;
        }, 500);
      }
    }
  }
</script>
